import { SYSTEM_LOG_SCOPE_FILTER_KEYS } from './system-log-explorer.js';

const LOCAL_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
const EXPORT_FILTER_KEYS = Object.freeze([
    ...SYSTEM_LOG_SCOPE_FILTER_KEYS,
    'actionMode',
    'sortBy',
    'sortOrder',
]);

export const SYSTEM_LOG_EXPORT_LIMIT = 10000;

export function buildLocalDateFilterPeriod(dateFrom, dateTo) {
    const period = {};
    if (dateFrom) period.dateFrom = new Date(`${dateFrom}T00:00:00.000`).toISOString();
    if (dateTo) period.dateTo = new Date(`${dateTo}T23:59:59.999`).toISOString();
    return period;
}

export function normalizeSystemLogDateFilters(filters = {}) {
    const normalized = { ...filters };
    if (LOCAL_DATE_PATTERN.test(String(filters.dateFrom || ''))) {
        normalized.dateFrom = buildLocalDateFilterPeriod(filters.dateFrom, '').dateFrom;
    }
    if (LOCAL_DATE_PATTERN.test(String(filters.dateTo || ''))) {
        normalized.dateTo = buildLocalDateFilterPeriod('', filters.dateTo).dateTo;
    }
    return normalized;
}

export function buildSystemLogExportFilters({
    searchParams = {},
    scope = 'filters',
    selectedLogIds = [],
    dateOverride = null,
} = {}) {
    const filters = {};
    for (const key of EXPORT_FILTER_KEYS) {
        const value = searchParams[key];
        if (Array.isArray(value) ? value.length > 0 : value !== '' && value != null) filters[key] = value;
    }

    if (!filters.action) delete filters.actionMode;
    if (dateOverride) {
        delete filters.dateFrom;
        delete filters.dateTo;
        Object.assign(filters, buildLocalDateFilterPeriod(dateOverride.dateFrom, dateOverride.dateTo));
    } else {
        Object.assign(filters, normalizeSystemLogDateFilters(filters));
    }

    if (scope === 'selected' && selectedLogIds.length > 0) {
        filters.selectedLogIds = [...new Set(selectedLogIds.map(String))];
    }
    return filters;
}

export function getSystemLogExportSummary(filters = {}) {
    return SYSTEM_LOG_SCOPE_FILTER_KEYS
        .filter((key) => {
            const value = filters[key];
            return Array.isArray(value) ? value.length > 0 : Boolean(value);
        })
        .map((key) => ({
            key,
            value: filters[key],
            mode: key === 'action' ? filters.actionMode || 'contains' : undefined,
        }));
}

export function normalizeSystemLogExportEstimate(value) {
    if (!value || !Number.isFinite(Number(value.matchedCount))) return null;
    const matchedCount = Math.max(0, Number(value.matchedCount));
    const limit = Number(value.limit) > 0 ? Number(value.limit) : SYSTEM_LOG_EXPORT_LIMIT;
    const exportableCount = Math.min(
        matchedCount,
        limit,
        Math.max(0, Number.isFinite(Number(value.exportableCount)) ? Number(value.exportableCount) : limit),
    );
    return {
        matchedCount,
        exportableCount,
        limit,
        truncated: value.truncated === true || matchedCount > exportableCount,
    };
}
